module.exports = __webpack_public_path__ + "img/Speaker=Shirley Moore.1c6b10cd.png";